// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xJRX","right":"Footer_right__MvceU","buttons":"Footer_buttons__2zsIB"};